@if(loaded){
<div #themeWrapper
  class="theme-wrapper {{themeService.customOrDefaultClass$|async}}  {{themeService.themeBrightnessClass$|async}}">

  <app-header #header></app-header>

  <app-main #main></app-main>

  <!-- <app-footer></app-footer> -->

</div>
}@else if(startupError){

<div #themeWrapper class="theme-wrapper default-theme startup-error">
  <mat-card appearance="outlined">
    <mat-card-content>
      <mat-icon color="warn">bug_report</mat-icon>
      <pre [innerHTML]="startupError | safe" class="mat-error">
      </pre>
    </mat-card-content>
  </mat-card>
</div>

}